import React, { FC } from 'react';
import { styled } from 'linaria/react';
import { Text } from '@shared/ui/atoms';
interface OperationStatusProps {
  icon: React.ReactNode;
  title: string | React.ReactNode;
  subtitle?: string;
  description?: string;
}
export const OperationStatus: FC<OperationStatusProps> = ({
  icon,
  title,
  subtitle,
  description
}) => <OperationStatusWrapper>
    <IconWrapper>{icon}</IconWrapper>
    <TextWrapper>
      <Text family="MTSWide" size={{
      desktop: 'h5',
      mobile: 'h6'
    }} weight="bold" color="primary" textTransform="none">
        {title}
      </Text>
      {subtitle && <Text family="MTSCompact" size={{
      desktop: 'pL',
      mobile: 'pM'
    }} weight="medium" color="secondary">
          {subtitle}
        </Text>}
      {description && <Text family="MTSCompact" size={{
      desktop: 'pL',
      mobile: 'pM'
    }} weight="medium" color="secondary">
          {description}
        </Text>}
    </TextWrapper>
  </OperationStatusWrapper>;
const OperationStatusWrapper = /*#__PURE__*/styled('div')({
  name: "OperationStatusWrapper",
  class: "o19u52i6",
  propsAsIs: false
});
const IconWrapper = /*#__PURE__*/styled('div')({
  name: "IconWrapper",
  class: "i9u4ld1",
  propsAsIs: false
});
const TextWrapper = /*#__PURE__*/styled('div')({
  name: "TextWrapper",
  class: "t1xqaqmx",
  propsAsIs: false
});

require("./OperationStatus.linaria.module.css!=!../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./OperationStatus.tsx");